import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DisclaimerTypes } from '../../../../../interfaces/disclaimertypes';
import { summariseObject } from '../user-rag.component';

@Component({
    selector: 'app-rag-raw-text',
    standalone: false,
    templateUrl: './rag-raw-text.component.html',
    styleUrl: './rag-raw-text.component.scss'
})
export class RagRawTextComponent {
    @Output() close = new EventEmitter<void>();
    @Output() usecontent = new EventEmitter<string>();


    protected disclaimerTypes = DisclaimerTypes;
    editResponse: boolean = false;
    loading: boolean = false;
    userInput: string = '';


    summariseText() {
        if (!this.userInput || this.userInput.trim().length === 0) {
            return;
        }

        this.usecontent.emit(this.userInput.trim());

        // this.editResponse = false;
    }
}
